import { render, staticRenderFns } from "./protocol-view.vue?vue&type=template&id=f838a04c&scoped=true&"
import script from "./protocol-view.vue?vue&type=script&lang=js&"
export * from "./protocol-view.vue?vue&type=script&lang=js&"
import style0 from "./protocol-view.vue?vue&type=style&index=0&id=f838a04c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f838a04c",
  null
  
)

export default component.exports